import {
  ClientUserInterface,
  ClientBelief,
  ClientThoughtWithAuthor,
  ClientFeed,
} from '../Admin-ClientLibrary';

export type EntityType = 'user' | 'belief' | 'thought' | 'feed';

export interface RecentEntity {
  id: string;
  type: EntityType;
  data: ClientUserInterface | ClientBelief | ClientThoughtWithAuthor | ClientFeed;
  accessedAt: Date;
}

export type Entity = ClientUserInterface | ClientBelief | ClientThoughtWithAuthor | ClientFeed;

export const MAX_RECENT_ENTITIES = 10;
